import React, { Component } from "react";
import firebase from "../../utils/firebase";
import _ from "lodash";
import { UserContext } from "../../Context";
import { Link } from "react-router-dom";

import Button from "@atlaskit/button";
import Lozenge from "@atlaskit/lozenge";
import Tag from "@atlaskit/tag";
import SectionMessage from "@atlaskit/section-message";
import Item, { ItemGroup } from "@atlaskit/item";
import DropList from "@atlaskit/droplist";
import HipchatChevronDownIcon from "@atlaskit/icon/glyph/hipchat/chevron-down";

import {
  APPLICATION_STATUSES,
  LOZENGE_STATUSES,
  APPLICATION_MESSAGES,
  RequiredProfile,
  ResubmitApplication
} from "../../utils/consts";

import "./appliedCard.css";
export default class AppliedCard extends Component {
  state = { droplistOpen: false };
  resubmit = uid => {
    ResubmitApplication(uid)
      .then(() => {
        this.props.addFlag({
          appearance: 2,
          title: "Application Resubmitted"
        });
      })
      .catch(error => {
        this.props.addFlag({
          appearance: 2,
          title: "Error - Please Try Again"
        });
        console.log(error);
      });
  };

  makeActive = application => {
    firebase
      .firestore()
      .collection("application")
      .doc(application.uid)
      .set(application)
      .then(() => {
        this.props.addFlag({
          appearance: 2,
          title: "Application Activated"
        });
      })
      .catch(error => console.log(error));
  };

  deleteInactiveApplication = application => {
    firebase
      .firestore()
      .collection("my")
      .doc(application.uid)
      .update({
        [`applications.${
          application.lid
        }`]: firebase.firestore.FieldValue.delete()
      })
      .then(() => {
        this.props.addFlag({
          appearance: 2,
          title: "Deleted"
        });
      })
      .catch(error => {
        this.props.addFlag({
          appearance: 2,
          title: "Error - Please Try Again"
        });
        console.log(error);
      });
  };

  deleteActiveApplication = application => {
    const promises = [];
    if (application.status === APPLICATION_STATUSES._PENDING_SIGNATURE) {
      const updateEmailSignature = firebase
        .functions()
        .httpsCallable("updateSignatureEmail");
      const cancelEmailPromise = updateEmailSignature({
        uuid: application.uuid,
        method: "cancel_signrequest"
      })
        .then(result => console.log(result.data))
        .catch(error => console.log(error));
      promises.push(cancelEmailPromise);
    }
    const myPromise = firebase
      .firestore()
      .collection("my")
      .doc(application.uid)
      .update({
        [`applications.${
          application.lid
        }`]: firebase.firestore.FieldValue.delete()
      });
    promises.push(myPromise);
    const applicationPromise = firebase
      .firestore()
      .collection("application")
      .doc(application.uid)
      .delete();
    promises.push(applicationPromise);
    Promise.all(promises)
      .then(() => {
        this.props.addFlag({
          appearance: 2,
          title: "Successfull Deleted"
        });
      })
      .catch(error => {
        this.props.addFlag({
          appearance: 2,
          title: "Error - Please Try Again"
        });
        console.log(error);
      });
  };

  resendSignatureEmail = application => {
    const uuid = application.uuid || "";
    if (!uuid) {
      return console.log("Error no UUID");
    }
    const resend = firebase.functions().httpsCallable("updateSignatureEmail");
    resend({ uuid, method: "resend_signrequest_email" })
      .then(result => {
        this.props.addFlag({
          appearance: 2,
          title: "Email Resent"
        });
      })
      .catch(error => {
        this.props.addFlag({
          appearance: 2,
          title: "Error - Please Try Again"
        });
        console.log(error);
      });
  };

  render() {
    if (this.props.hideCard) {
      return null;
    } else {
      return (
        <UserContext.Consumer>
          {userContext => {
            const listing = this.props.listing || {};
            const application = userContext.application || {};
            // console.log(application);
            const user = userContext.user || {};
            const my = userContext.my || {};
            const applications = userContext.my.applications || {};
            // console.log(userContext);
            const status = application.status || "evaluating";
            return (
              <div className="applied-card">
                {!this.props.hideTitle && (
                  <div className="applied-active__title">
                    <span className="applied-active__title_default">
                      {application.lid === listing.lid ? "ACTIVE" : "INACTIVE"}{" "}
                      APPLICATION
                    </span>
                  </div>
                )}
                {!this.props.hideSection && (
                  <div className="applied-active__status">
                    {application.lid === listing.lid ? (
                      <SectionMessage
                        appearance={APPLICATION_MESSAGES[status].appearance}
                        title={APPLICATION_MESSAGES[status].title}
                      >
                        <p>{APPLICATION_MESSAGES[status].message}</p>
                      </SectionMessage>
                    ) : (
                      <SectionMessage
                        appearance={APPLICATION_MESSAGES.inactive.appearance}
                        title={APPLICATION_MESSAGES.inactive.title}
                      >
                        <p>{APPLICATION_MESSAGES.inactive.message}</p>
                      </SectionMessage>
                    )}
                  </div>
                )}
                {!this.props.hideMissing &&
                  status === APPLICATION_STATUSES._INCOMPLETE && (
                    <div className="applied-active__missing-items">
                      <span className="applied-active__missing">Missing: </span>
                      {Object.keys(RequiredProfile)
                        .filter(field => !my[field])
                        .map(field => (
                          <Tag
                            key={field}
                            href={`/profile?t=${RequiredProfile[field]}`}
                            text={field}
                          />
                        ))}
                      <p>
                        <Link
                          className="applied-action-btn__complete-profile"
                          to={`/profile?t=${_.first(
                            Object.keys(RequiredProfile).filter(
                              field => !my[field]
                            )
                          )}`}
                        >
                          <Button shouldFitContainer appearance="default">
                            Complete Profile
                          </Button>
                        </Link>
                      </p>
                    </div>
                  )}
                {!this.props.hideActions && (
                  <div className="applied-active__actions">
                    <span className="applied-active__lozenges">
                      {application.lid === listing.lid ? (
                        <Lozenge
                          className="applied-active__status-lozenge"
                          appearance={
                            LOZENGE_STATUSES[status] ||
                            LOZENGE_STATUSES.evaluating
                          }
                        >
                          {!!status && status.split("_").join(" ")}
                        </Lozenge>
                      ) : (
                        <Lozenge
                          className="applied-active__status-lozenge"
                          appearance={LOZENGE_STATUSES.inactive}
                        >
                          INACTIVE
                        </Lozenge>
                      )}
                    </span>
                    <DropList
                      isOpen={this.state.droplistOpen}
                      onClick={() =>
                        this.setState({
                          droplistOpen: !this.state.droplistOpen
                        })
                      }
                      appearance="default"
                      position="bottom right"
                      trigger={
                        <Button appearance="subtle-link" spacing="none">
                          <HipchatChevronDownIcon />
                        </Button>
                      }
                    >
                      {application.lid === listing.lid ? (
                        <ItemGroup>
                          {status === APPLICATION_STATUSES._INCOMPLETE && (
                            <Item
                              className="appied-action-btn__resubmit"
                              onClick={() => this.resubmit(user.uid)}
                            >
                              Resubmit
                            </Item>
                          )}
                          {status ===
                            APPLICATION_STATUSES._PENDING_SIGNATURE && (
                            <Item
                              className="appied-action-btn__resend"
                              onClick={() => {
                                this.resendSignatureEmail(application);
                              }}
                            >
                              Resend Agreement
                            </Item>
                          )}
                          {!!status && (
                            <Item
                              className="appied-action-btn__delete"
                              onClick={() =>
                                this.deleteActiveApplication(application)
                              }
                            >
                              Delete
                            </Item>
                          )}
                        </ItemGroup>
                      ) : (
                        <ItemGroup>
                          <Item
                            className="appied-action-btn__resubmit"
                            onClick={() =>
                              this.makeActive(applications[listing.lid])
                            }
                          >
                            Resubmit & Activate
                          </Item>
                          <Item
                            className="appied-action-btn__delete"
                            onClick={() =>
                              this.deleteInactiveApplication(
                                applications[listing.lid]
                              )
                            }
                          >
                            Delete
                          </Item>
                        </ItemGroup>
                      )}
                    </DropList>
                  </div>
                )}
              </div>
            );
          }}
        </UserContext.Consumer>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/AppliedCard/AppliedCard.js